import React from 'react';
import Grid from '@mui/material/Grid';
import { Card, Box } from '@mui/material';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Container } from '@mui/material';
import ContactForm from '../components/ContactForm';
import { List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/Circle';

function Konnyuszerkezetes() {
  return (
    <Container disableGutters >
      <Typography variant="h4" marginTop={6} marginLeft={2}>
          Vállaljuk a teljes kivitelezést az alapoktól a kész házig!
      </Typography>
      <Typography margin={2}></Typography>      
          <Typography variant="h6" marginLeft={2} marginRight={2}>
            <Typography variant="h6">
            A könnyűszerkezetes házak népszerűségét elsősorban gyors kivitelezésüknek és kedvező áruknak köszönhetik. 
            Az építési idő általában néhány hónap, ami jóval rövidebb a hagyományos technológiákhoz képest. Az anyagfelhasználás hatékonyabb, így a költségek is alacsonyabbak lehetnek, miközben a modern szigetelési technológiáknak köszönhetően energiatakarékos otthonok épülnek. 
            A tervezés rugalmas, könnyen testre szabható az egyéni igények szerint, és az időjárás is kevésbé befolyásolja a folyamatot. 
            Ideális választás lehet azoknak, akik gyorsan, költséghatékonyan és környezettudatosan szeretnének otthont teremteni.
            </Typography>
            <Typography margin={2}></Typography>   
            <Typography variant="h6">
            Nálunk nincsenek sablonok vagy előre legyártott panelek – minden házat egyedileg, az Ön igényeihez és a telek adottságaihoz igazítva építünk meg. Könnyűszerkezetes házainkat három különböző készültségi szinten kínáljuk, így Ön döntheti el, mennyit szeretne rábízni ránk – és így akár több százezer forintot is megspórolhat.     
            </Typography>
            <Grid container spacing={3} marginTop={4}  justifyContent="center">              
              <Box boxShadow={4} marginLeft={2}>
                <Card>
                  <CardMedia component="img" src='./images/szerkezetkesz.jpg' alt='Szerkezetkész ház' />          
                </Card>
              </Box>          
            </Grid>
            <Typography variant="h4" marginTop={6}>Árak</Typography>
            <Grid container spacing={3} columns={16} marginTop={4} justifyContent="center">
              <Grid item xs={16} sm={12} md={8} >
                <Box boxShadow={4} padding={4} sx={{ bgcolor: 'white', color: 'black' }}>
                <Typography variant="h4" marginBottom={4} >Szerkezetkész</Typography>
                <Typography variant="h8" marginTop={4} marginBottom={4}>Ebben a fázisban elkészül az alapozás, felépül a ház teherhordó váza, a külső falak, a tetőszerkezet és gyakran a héjazat is. 
                    A ház kívülről már jól körülhatárolható, de belül még nincs sem gépészet, sem válaszfalak, sem nyílászárók. Ez az első komolyabb mérföldkő az építkezés során.</Typography>
                <Typography margin={6}></Typography>
                <Typography variant="h5" margin={4}>245.000 Ft+ÁFA-tól</Typography>
                <Card>
                  <CardMedia component="img" src='./images/Szerkezetkesz.png' alt='Tetőfedés' />          
                </Card>
                </Box>
              </Grid>
              <Grid item xs={16} sm={12} md={8} >
                <Box boxShadow={4} padding={4} sx={{ bgcolor: 'white', color: 'black' }}>
                  <Typography variant="h4" marginBottom={4}>Félkész</Typography>
                  <Typography variant="h8" marginTop={4}>A szerkezetkészen túl itt már bekerülnek a nyílászárók, válaszfalak, valamint a gépészeti (víz, villany, fűtés) alapszerelések is megtörténnek. 
                    Az épület hőszigetelése, vakolása, belső elrendezése is kialakul, de a végső burkolatok, szaniterek és festés még hiányzik. </Typography>
                    <Typography margin={6}></Typography>
                    <Typography variant="h5" margin={4}>295.000 Ft+ÁFA-tól</Typography>
                  <Card>
                    <CardMedia component="img" src='./images/Felkesz.png' alt='Autóbeállók készítése' />          
                  </Card>
                </Box>
              </Grid>
              <Grid item xs={16} sm={12} md={8} >
              <Box boxShadow={4} padding={4} sx={{ bgcolor: 'white', color: 'black' }}>
                <Typography variant="h4" marginBottom={4}>Kulcsrakész</Typography>
                <Typography variant="h8" marginTop={4}>Ez a teljesen kész, beköltözhető állapot, amely tartalmaz minden burkolatot, szanitert, belső ajtót, festést és világítást is. 
                    A fűtésrendszer beüzemelve, a konyha előkészítve, lényegében csak a bútorokat kell bevinni, és költözhető az otthon.</Typography>
                <Typography margin={6}></Typography>
                <Typography variant="h5" margin={4}>395.000 Ft+ÁFA-tól</Typography>
                <Card>
                  <CardMedia component="img" src='./images/Kulcsrakesz.png' alt='Előtetők készítése' />          
                </Card>
                </Box>
              </Grid>
              </Grid>
              <Typography variant="h6" marginTop={4} >
                Könnyűszerkezetes ház áraink nem tartalmazzák az alábbiakat:
              </Typography>
              <Grid marginLeft={4}>
              <List >
                <ListItem>
                    <ListItemIcon>
                    <CheckCircleIcon color="black" />
                    </ListItemIcon>
                    <ListItemText primary="Tervezés" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                    <CheckCircleIcon color="black" />
                    </ListItemIcon>
                    <ListItemText primary="Járda, kerítés" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                    <CheckCircleIcon color="black" />
                    </ListItemIcon>
                    <ListItemText primary="Házon kívüli közmű-bekötés" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                    <CheckCircleIcon color="black" />
                    </ListItemIcon>
                    <ListItemText primary="Kertrendezés" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                    <CheckCircleIcon color="black" />
                    </ListItemIcon>
                    <ListItemText primary="Burkolatok és szaniterek" />
                </ListItem>
              </List>
              </Grid>
              <Typography variant="h6" marginTop={4}>
              A árak nagyon sok mindentől függenek, így azok részben tájékoztató jelegűek, kisebb eltérések tapasztalhatóak piaci helyzet függvényében. Ezért érdemes előszerződést kötni, amiben garantálni tudjuk fix árakat.
              </Typography>

              <Typography variant="h6" marginTop={4}>
                Amennyiben felkeltettük érdeklődését, örömmel állok rendelkezésére!
              </Typography>
            
          </Typography>
      <Typography margin={6}></Typography>
      <ContactForm/>
    </Container> 
  );
}

export default Konnyuszerkezetes;